import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { IQRASavedStateViewInfo, IQRASavedStateSliceStates } from './types'

const initialState: IQRASavedStateSliceStates = {}

const qraSavedStateSlice = createSlice({
  name: 'qra-saved-state',
  initialState,
  reducers: {
    setSavedStateViewInfo: (
      state,
      action: PayloadAction<IQRASavedStateViewInfo>
    ) => {
      state.stateViewInfo = action.payload
    },
    setSavedStateDetailsId: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.detailsId = action.payload
    }
  }
})

export const {
  setSavedStateViewInfo: setSavedStateViewInfoSync,
  setSavedStateDetailsId: setSavedStateDetailsIdSync
} = qraSavedStateSlice.actions

export default qraSavedStateSlice.reducer
